import logo from '../assets/logo.png';

const Logo = ({ className = "h-10" }) => (
  <img src={logo} alt="HeadIT" className={className} />
);

export default Logo;
